export default __webpack_public_path__ + "static/media/video_preview.4b0a7c50.png";